import { render } from "./Introscherm3.vue?vue&type=template&id=599c53e6&scoped=true&ts=true"
import script from "./Introscherm3.vue?vue&type=script&lang=ts"
export * from "./Introscherm3.vue?vue&type=script&lang=ts"

import "./Introscherm3.vue?vue&type=style&index=0&id=599c53e6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-599c53e6"]])

export default __exports__